<template>
    <textarea ref="textarea" class="is-resizable" v-model="val" rows="1" :name="name"></textarea>
</template>

<script>
export default {
    props: {
        name: {
            type: String,
            required: true
        },
        value: {
            required: false
        },
        minheight: {
            type: Number,
            default: 98
        }
    },
    data() {
        return {
            val: null
        }
    },
    methods: {
        resize() {
            this.$refs.textarea.style.height = "auto";

            let height = this.$refs.textarea.scrollHeight;

            if ( height < this.minheight ) {
                height = this.minheight;
            }

            this.$refs.textarea.style.height = height + "px";
        }
    },
    watch: {
        value(val) {
            this.val = val;
        },
        val() {
            this.$nextTick(this.resize);
            this.$emit('input', this.val);
        }
    },
    mounted() {
        this.val = this.value;
    }

}
</script>
